import {
  Dispatch, SetStateAction, useCallback, useMemo, useState, 
} from 'react'

type ToggleAction = () => void
type UseToggle = [boolean, ToggleAction, Dispatch<SetStateAction<boolean>>]

const useToggle = (initial: boolean | (() => boolean)): UseToggle => {
  const [value, setValue] = useState(initial)

  const toggle = useCallback(() => {
    setValue((current) => !current)
  }, [])

  return useMemo(() => [value, toggle, setValue], [value, toggle, setValue])
}

export default useToggle
